export default "__VITE_ASSET__BxLv8NH8__"